import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';
import { MoveInboxRuleState } from './actions/moveInboxRule';
import { RuleBulkActionCustomData } from './orchestrators/runRuleNowOrchestrator';
import InboxRuleActionSource from './store/schema/InboxRuleActionSource';
import NewInboxRuleData from 'owa-service/lib/contract/NewInboxRuleData';
import { InitializeInboxRulesFoldersState } from './actions/helpers/initializeInboxRulesFolders';
import newInboxRuleAction from './actions/newInboxRuleAction';
import InboxRule from 'owa-service/lib/contract/InboxRule';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Options" */ './lazyIndex'));

// export types
export {
    InboxRule,
    InboxRuleActionSource,
    InitializeInboxRulesFoldersState,
    MoveInboxRuleState,
    newInboxRuleAction,
    NewInboxRuleData,
    RuleBulkActionCustomData,
};

export let lazyMoveInboxRule = new LazyAction(lazyModule, m => m.moveInboxRule);
export let lazyRunRuleNow = new LazyImport(lazyModule, m => m.runRuleNow);
export let lazyInitializeInboxRulesFolders = new LazyAction(
    lazyModule,
    m => m.initializeInboxRulesFolders
);
